import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import constants from "../../constants";
import STORAGE_KEYS from "../../constants/storage-keys";
import auth from "../auth";
import http from "../http";
import { interceptors, REQUEST_INTERCEPTORS_NAMES } from "../common";
var LINKED_ACCOUNTS_ENDPOINT = "".concat(constants.API_URL, "/users/me/linked-accounts");
var USERS_ENDPOINT = "".concat(constants.API_URL_V1, "/users");
var tokenKey = STORAGE_KEYS.TOKEN_KEY;
var refreshTokenKey = STORAGE_KEYS.REFRESH_TOKEN_KEY;
var refreshTokenKeyId = STORAGE_KEYS.REFRESH_TOKEN_ID_KEY;

function listLinkedAccounts() {
  return _listLinkedAccounts.apply(this, arguments);
}

function _listLinkedAccounts() {
  _listLinkedAccounts = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var response;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return http.get("".concat(LINKED_ACCOUNTS_ENDPOINT));

          case 2:
            response = _context.sent;
            return _context.abrupt("return", response);

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _listLinkedAccounts.apply(this, arguments);
}

function listPrimaryLinkedAccounts() {
  return _listPrimaryLinkedAccounts.apply(this, arguments);
}

function _listPrimaryLinkedAccounts() {
  _listPrimaryLinkedAccounts = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
    var response;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return http.get("".concat(LINKED_ACCOUNTS_ENDPOINT, "/primary"));

          case 2:
            response = _context2.sent;
            return _context2.abrupt("return", response);

          case 4:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _listPrimaryLinkedAccounts.apply(this, arguments);
}

function addLinkedAccount(_x) {
  return _addLinkedAccount.apply(this, arguments);
}

function _addLinkedAccount() {
  _addLinkedAccount = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(account) {
    var response;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return http.post(LINKED_ACCOUNTS_ENDPOINT, account);

          case 2:
            response = _context3.sent;
            return _context3.abrupt("return", response);

          case 4:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _addLinkedAccount.apply(this, arguments);
}

function removeSecondaryLinkedAccount(_x2) {
  return _removeSecondaryLinkedAccount.apply(this, arguments);
}

function _removeSecondaryLinkedAccount() {
  _removeSecondaryLinkedAccount = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(_ref) {
    var userId, passwordConfirmation, response;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            userId = _ref.userId, passwordConfirmation = _ref.passwordConfirmation;
            _context4.next = 3;
            return http.post("".concat(LINKED_ACCOUNTS_ENDPOINT, "/").concat(userId, "/unlink"), passwordConfirmation);

          case 3:
            response = _context4.sent;
            return _context4.abrupt("return", response);

          case 5:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
  return _removeSecondaryLinkedAccount.apply(this, arguments);
}

function removePrimaryLinkedAccount(_x3) {
  return _removePrimaryLinkedAccount.apply(this, arguments);
}

function _removePrimaryLinkedAccount() {
  _removePrimaryLinkedAccount = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(_ref2) {
    var userId, passwordConfirmation, _yield$http$post, data;

    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            userId = _ref2.userId, passwordConfirmation = _ref2.passwordConfirmation;
            _context5.next = 3;
            return http.post("".concat(USERS_ENDPOINT, "/").concat(userId, "/linked-accounts/me/unlink"), passwordConfirmation, {
              params: {
                shouldPopulateUserInfo: false
              }
            });

          case 3:
            _yield$http$post = _context5.sent;
            data = _yield$http$post.data;
            auth.getStorageAPI().setItem(tokenKey, data.jwt);
            auth.getStorageAPI().setItem("user", JSON.stringify(data.user));
            http.setJwt(data.jwt);

          case 8:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));
  return _removePrimaryLinkedAccount.apply(this, arguments);
}

function removeLinkedAccount(_x4) {
  return _removeLinkedAccount.apply(this, arguments);
}

function _removeLinkedAccount() {
  _removeLinkedAccount = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(params) {
    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            if (!params.isPrimary) {
              _context6.next = 2;
              break;
            }

            return _context6.abrupt("return", removePrimaryLinkedAccount(params));

          case 2:
            return _context6.abrupt("return", removeSecondaryLinkedAccount(params));

          case 3:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  }));
  return _removeLinkedAccount.apply(this, arguments);
}

function switchToLinkedAccount(_x5) {
  return _switchToLinkedAccount.apply(this, arguments);
}

function _switchToLinkedAccount() {
  _switchToLinkedAccount = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(_ref3) {
    var userId, refreshTokenId, callback, interceptorId, _yield$http$get, data;

    return _regeneratorRuntime.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            userId = _ref3.userId, refreshTokenId = _ref3.refreshTokenId, callback = _ref3.callback;
            interceptorId = http.addRequestInterceptor({
              interceptorName: REQUEST_INTERCEPTORS_NAMES.UPDATE_HEADER_REFRESH_TOKEN,
              beforeRequestInterceptor: interceptors.updateHeaderRefreshToken(refreshTokenKeyId)
            });
            _context7.next = 4;
            return http.get("".concat(constants.API_URL_V2, "/users/").concat(userId, "/token"), {
              params: {
                shouldPopulateUserInfo: false,
                refreshTokenId: refreshTokenId
              }
            });

          case 4:
            _yield$http$get = _context7.sent;
            data = _yield$http$get.data;
            http.removeRequestInterceptor(interceptorId);
            if (callback) callback();
            auth.getStorageAPI().setItem(tokenKey, data.jwt);
            auth.getStorageAPI().setItem("user", JSON.stringify(data.user));
            auth.getStorageAPI().setItem(refreshTokenKey, data.refreshToken);
            auth.getStorageAPI().setItem(refreshTokenKeyId, data.refreshTokenId);
            http.setJwt(data.jwt);

          case 13:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7);
  }));
  return _switchToLinkedAccount.apply(this, arguments);
}

export default {
  listLinkedAccounts: listLinkedAccounts,
  listPrimaryLinkedAccounts: listPrimaryLinkedAccounts,
  addLinkedAccount: addLinkedAccount,
  removeLinkedAccount: removeLinkedAccount,
  switchToLinkedAccount: switchToLinkedAccount
};